import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { recipeDetailCategory } from 'src/app/core/model/api-response/recipe-response-model';
import { RecipeDetailModel } from 'src/app/core/model/object/recipe-model';
import { CookingStoryService } from 'src/app/data/repository/cooking-story/cooking-story.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import Num2persian from 'src/app/utils/num2persian';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';

@Component({
  selector: 'app-cooking-story-tutorial',
  templateUrl: './cooking-story-tutorial.component.html',
  styleUrls: ['./cooking-story-tutorial.component.scss'],
})
export class CookingStoryTutorialComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  recipeId: string;
  recipe: RecipeDetailModel;
  categorie: recipeDetailCategory;
  instructions: number;
  activePage: number = 0;
  liked: boolean = false;
  showReport: boolean = false;
  distance: string[] = [];
  loading: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(
    private recipeService: RecipeService,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
    private bottomsheetShared: BottomsheetShared,
    private router: Router,
    private cookingstory: CookingStoryService
  ) {
    const recipe = this.cookingstory.getRecipe();
    this.recipeId = this.route.snapshot.paramMap.get('recipeId');

    if (recipe) {
      this.recipe = recipe.recipe;
      this.categorie = recipe.category;
      this.liked = this.recipe.bookmark;
      this.calcInstructions();
    } else {
      this.getRecipeDetail();
    }
    const sub = this.bottomsheetShared.closeBottomsheetObs$.subscribe(() => {
      this.showReport = false;
    });
    this.subscriptions.push(sub);
  }

  Bookmarking() {
    this.liked = !this.liked;
    this.recipeService.bookmark(this.recipeId);
  }

  share() {
    const newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      window.navigator.share({
        url: this.router.url,
      });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.bottomsheetShared.shareLink;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('لینک پست کپی شد');
    }
  }
  calcDistance() {
    if (this.instructions) {
      for (let i = 0; i < this.instructions; i++) {
        if (i < this.activePage) {
          this.distance[i] = '-' + (this.activePage - i) * 100 + '%';
        } else if (i > this.activePage) {
          this.distance[i] = (this.activePage + i) * 100 + '%';
        } else {
          this.distance[i] = 0 + '%';
        }
      }
      this.loading = true;
    }
  }
  showReportbottomSheet() {
    this.showReport = true;
  }
  ngAfterViewInit() {
    let checker = setInterval(() => {
      this.changeStep(this.activePage);
      if (
        document.getElementById('hover')?.clientWidth ==
        document.getElementById('step' + this.activePage)?.clientWidth
      ) {
        clearInterval(checker);
      }
    }, 700);
  }

  calcInstructions() {
    this.instructions = this.recipe.instructions.length;
    this.distance = new Array(this.instructions).fill('200%');
  }

  nextPage(index?: number) {
    if (index || index == 0) {
      this.activePage = index;
      this.changeStep(index);
    } else {
      this.activePage = this.activePage + 1;
      this.changeStep(this.activePage);
    }
  }
  swipe(swiped) {
    if (swiped == 'swipeleft') {
      if (this.activePage > 0) {
        this.nextPage(this.activePage - 1);
      }
    } else if (swiped == 'swiperight') {
      if (this.activePage < this.instructions) {
        this.nextPage(this.activePage + 1);
      }
    }
  }

  changeStep(index: number) {
    const step = document.getElementById('step' + index);
    this.calcDistance();
    if (step) {
      document.getElementById('hover').style.left = step.offsetLeft + 'px';
      document.getElementById('hover').style.width = step.clientWidth + 'px';
    }
  }

  changePage(index: number) {
    return Num2persian(index + 1);
  }

  garr(n: number) {
    if (n && n > 0) {
      n++;
      return new Array(n);
    }
  }

  async getRecipeDetail() {
    this.recipeService.getRecipeDetail(this.recipeId, true).then((res) => {
      if (res.isSuccess()) {
        this.recipe = res.getData().getCookingStoryRecipe().recipe;
        this.categorie = res.getData().getCookingStoryRecipe().category;
        this.liked = this.recipe.bookmark;
        this.calcInstructions();
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  openRecipe() {
    //  this.recipeService.goToRecipeDetail(this.recipeId);
    this.recipeService.back();
  }

  ngOnInit(): void {}
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
